import { render } from "./LeaguesTreeView.vue?vue&type=template&id=07dfedef&scoped=true"
import script from "./LeaguesTreeView.vue?vue&type=script&lang=js"
export * from "./LeaguesTreeView.vue?vue&type=script&lang=js"

import "./LeaguesTreeView.vue?vue&type=style&index=0&id=07dfedef&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07dfedef"]])

export default __exports__